import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import React from 'react';
import { AppState, WrappedAppActions } from 'records/AppState';

export interface WithAppStoreProps {
  appState: AppState;
  actions: WrappedAppActions;
  appStore: AppStore;
}

interface Props {
  children: (appStore: AppStore) => React.ReactElement;
}

export class WithAppStore extends React.Component<Props, {}, AppStore> {
  static contextType = AppStoreContext;

  context!: React.ContextType<typeof AppStoreContext>;

  render(): React.ReactNode {
    return this.props.children(this.context);
  }
}

export default function withAppStore<P extends WithAppStoreProps>(
  // TODO: Would love to remove the 'any' below at some point.
  Component: React.ComponentClass<any> | React.FunctionComponent<any>
): React.FunctionComponent<Omit<P, 'appState' | 'actions' | 'appStore'>> {
  return (
    props: Omit<P, 'appState' | 'actions' | 'appStore'>
  ): React.ReactElement => {
    return (
      <WithAppStore>
        {(appStore): React.ReactElement => (
          <Component
            {...props}
            appState={appStore.state}
            actions={appStore.actions}
            appStore={appStore}
          />
        )}
      </WithAppStore>
    );
  };
}
